import { cn } from '@/shared/utils';
import { motion } from 'motion/react';
import { FlowerSpinner } from './flower-spinner';

interface Props {
  className?: string;
  overlay?: boolean;
}

export function PageLoader({ className, overlay = false }: Props) {
  return (
    <motion.div
      className={cn('absolute flex h-full w-full items-center justify-center', className)}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {overlay && <div className="absolute inset-0 bg-white opacity-80" />}
      <FlowerSpinner />
    </motion.div>
  );
}
